import { useState } from 'react';
import { Box, TextField, InputAdornment, Card, CardContent } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useDebounce } from '@/shared/hooks';
import { LoadingSpinner, EmptyState } from '@/shared/components';
import { useJobsQuery } from '../hooks/useJobsQuery';
import JobsList from './JobsList';
import JobsPagination from './JobsPagination';

export default function JobsHistoryContainer() {
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const debouncedSearch = useDebounce(search, 500);

  const { data, isLoading, error } = useJobsQuery({
    page,
    limit: 10,
    search: debouncedSearch || undefined,
  });

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
    setPage(1); // Reset to first page on search
  };

  if (error) {
    return (
      <EmptyState
        title="Error al cargar el historial"
        description="No se pudo cargar el historial de jobs. Intenta nuevamente."
      />
    );
  }

  return (
    <Card>
      <CardContent>
        {/* Search */}
        <Box sx={{ mb: 3 }}>
          <TextField
            fullWidth
            placeholder="Buscar por URL o Model ID..."
            value={search}
            onChange={handleSearchChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon color="action" />
                </InputAdornment>
              ),
            }}
            size="small"
          />
        </Box>

        {/* Content */}
        {isLoading ? (
          <LoadingSpinner message="Cargando historial..." />
        ) : !data?.jobs.length ? (
          <EmptyState
            title="No hay jobs"
            description={
              search
                ? 'No se encontraron jobs que coincidan con la búsqueda.'
                : 'Aún no has realizado ninguna traducción.'
            }
          />
        ) : (
          <>
            <JobsList jobs={data.jobs} />
            <JobsPagination
              page={data.page}
              totalPages={data.totalPages}
              onPageChange={setPage}
            />
          </>
        )}
      </CardContent>
    </Card>
  );
}
